import { Map } from 'immutable';

import {
  APP_STORAGE_FETCH_SETTINGS,
  APP_STORAGE_UPDATE_SETTINGS,
  APP_STORAGE_KIND,
  APP_STORAGE_SETTING_ORIENTATIONS,
  APP_STORAGE_SETTINGS,
} from './../constants';

const {
  PROXY,
  PROXY_ENABLED,
  INSTRUMENTATION,
  INSTRUMENTATION_ENABLED,
  BYPASS_SCREENSHOT_RESTRICTION,
  ORIENTATION,
  LANG,
  RESIGNING_ENABLED,
  RESIGNING,
  BIOMETRICS,
  IMAGE_INJECTION,
  GROUP_DIRECTORY,
  SYS_ALERTS_DELAY,
} = APP_STORAGE_SETTINGS;

const initialState = Map({
  proxy: null,
  proxy_enabled: null,
  lang: null,
  orientation: null,
  // IOS settings
  resigning: Map({
    image_injection: null,
    group_directory: null,
    biometrics: null,
    sys_alerts_delay: null,
  }),
  resigning_enabled: null,
  // Android settings
  instrumentation: Map({
    image_injection: null,
    bypass_screenshot_restriction: null,
  }),
  instrumentation_enabled: null,
  loading: false,
});

const getSettingsByAppKind = ({ settings, kind }, state) => {
  if (kind === APP_STORAGE_KIND.ANDROID) {
    return state.withMutations((mutable) => {
      mutable
        .set(INSTRUMENTATION_ENABLED.id, settings.instrumentation_enabled)
        .setIn([INSTRUMENTATION.id, IMAGE_INJECTION.id], settings.instrumentation.image_injection)
        .setIn(
          [INSTRUMENTATION.id, BYPASS_SCREENSHOT_RESTRICTION.id],
          settings.instrumentation.bypass_screenshot_restriction);
    });
  }

  if (kind === APP_STORAGE_KIND.IOS) {
    return state.withMutations((mutable) => {
      mutable
        .set(RESIGNING_ENABLED.id, settings.resigning_enabled)
        .setIn([RESIGNING.id, IMAGE_INJECTION.id], settings.resigning.image_injection)
        .setIn([RESIGNING.id, GROUP_DIRECTORY.id], settings.resigning.group_directory)
        .setIn([RESIGNING.id, BIOMETRICS.id], settings.resigning.biometrics)
        .setIn([RESIGNING.id, SYS_ALERTS_DELAY.id], settings.resigning.sys_alerts_delay);
    });
  }
  return null;
};

const updateSettingsByAppKind = (setting, appKind, state) => {
  if (appKind === APP_STORAGE_KIND.ANDROID && (
    setting.name === IMAGE_INJECTION.id ||
    setting.name === BYPASS_SCREENSHOT_RESTRICTION.id
  )) {
    return state.setIn([INSTRUMENTATION.id, setting.name], setting.value);
  }
  if (appKind === APP_STORAGE_KIND.IOS && (
    setting.name === IMAGE_INJECTION.id ||
    setting.name === BIOMETRICS.id ||
    setting.name === GROUP_DIRECTORY.id ||
    setting.name === SYS_ALERTS_DELAY.id
  )) {
    return state.setIn([RESIGNING.id, setting.name], setting.value);
  }
  if (setting.name === PROXY.id) {
    return state.withMutations((mutable) => {
      mutable
        .set(PROXY.id, setting.value)
        .set(PROXY_ENABLED.id, setting.proxy_enabled);
    });
  }
  return state.set(setting.name, setting.value);
};

const appStorageSettingsReducer = (state = initialState, { type, payload, meta }) => {
  switch (type) {
    case APP_STORAGE_FETCH_SETTINGS.REQUEST: {
      return state.set('loading', true);
    }
    case APP_STORAGE_FETCH_SETTINGS.SUCCESS: {
      const { settings } = payload;

      const settingsByAppKind = getSettingsByAppKind(payload, initialState);
      // { orientation: null } sets the device orientation to device default
      const orientation = settings.orientation ?
        settings.orientation : APP_STORAGE_SETTING_ORIENTATIONS.DEFAULT;

      return state.withMutations((mutable) => {
        mutable
          .merge(settingsByAppKind)
          .set(PROXY_ENABLED.id, settings.proxy_enabled)
          .set(PROXY.id, settings.proxy)
          .set(LANG.id, settings.lang)
          .set(ORIENTATION.id, orientation)
          .set('loading', false);
      });
    }
    case APP_STORAGE_UPDATE_SETTINGS.REQUEST: {
      const { setting, appKind } = payload;
      return updateSettingsByAppKind(setting, appKind, state);
    }
    case APP_STORAGE_UPDATE_SETTINGS.FAILURE:
    case APP_STORAGE_UPDATE_SETTINGS.CANCEL: {
      const { appKind } = payload;
      const { previousSetting } = meta;
      return updateSettingsByAppKind(previousSetting, appKind, state);
    }
    case APP_STORAGE_FETCH_SETTINGS.FAILURE:
    default:
      return state;
  }
};

export default appStorageSettingsReducer;
export { initialState };
